import { AbstractControl, FormArray, ValidatorFn } from '@angular/forms';

/**
 * Factory for domain name validator.
 */
export function domainValidatorFactory(maxLength: string | number): ValidatorFn {
  /*
    The domain name:
    - should be a-z (i.e. case insensitive) or 0-9 and hyphen (-)
    - should be between 1 and maxLength characters long
    - should not start or end with a hyphen(-)
    - the last top level domain must be 2-6 characters
    - the domain name can be a subdomain
  */
  const re = new RegExp(`^((?!-)[a-z0-9-]{1,${maxLength}}(?<!-)\\.)+[a-z]{2,6}$`, 'i');

  return (control: AbstractControl) => (re.test(control.value) ? null : { domainName: true });
}

/**
 * Factory for domains array validator.
 * @param maxChars - max total chars count in all domains
 */
export function domainsValidatorFactory(maxChars: number): ValidatorFn {
  return (array: FormArray) => {
    /*
      By Raj's request, here must be validation by total count of chars in all domains (100 chars max).
      Vals saved to DB as string with comma separated values.

      TODO: this validation should be reviewed. Better way is validate count of array items and chars count in each item.
    */
    let totalChars = array.controls.reduce((acc, control) => acc + control.value.length, 0);

    if (array.controls.length > 1) {
      totalChars += array.controls.length - 1; // add 1 char for each separator ","
    }

    if (totalChars > maxChars) {
      return { domainsTotalChars: true };
    }

    return null;
  };
}
